(function CarSearchResults($, Adzuki)
{
	"use strict";


	$(document).ready(function documentReady()
	{
		Adzuki.onload('CarBooking/searchResults', function onload()
		{
			var $results_map = $(".car-results-map"),
			    results_map;

			if ($results_map.length)
			{
				results_map = new Adzuki.Map('.car-results-map');
				results_map.populate($results_map.data('results'));

				$("a.goto-marker").click(function gotoMarker(e) {
					e.preventDefault();
					results_map.selectMarker($(this).data('marker-id'));
				});

				$("a.no-marker").click(function noMarker(e) {
					e.preventDefault();
					Adzuki.StatusMessage('warning', 'No location data available for this vendor.', 'Notice');
				});
			}

			$(".btn-group.style-toggle label").click(function changeStyle()
			{
				var $self = $(this);

				if (!$self.hasClass('active')) {
					window.location.href = Adzuki.base_uri + '/CarBooking/searchResults/'+$self.data('style');
				}
			});
		});
	});

}(jQuery, window.Adzuki || {}));